import Vue from 'vue'
import { AdminStore } from 'stylemix-vue-admin'
import gateModule from './store'

AdminStore.registerModule('gate', gateModule)

Vue.prototype.$allows = function(permission) {
  return this.$store.state.gate.permissions[permission]
}
